<template>
    <div v-if="type != 'button' && type != 'link'"
        class="fav-element"
        role="button"
        @click.prevent="toggleFav"
        @keydown.enter.prevent="toggleFav"
        @keydown.space.prevent="toggleFav"
        :title="title"
        tabindex="0">
        <i aria-hidden="true"
            :class="{'fa-solid fa-heart': isFav(), 'fa-sharp fa-light fa-heart': !isFav()}"></i>
        <span class="sr-only"
            v-show="!isFav()">{{ voMsg('tpl.text.addFavLabel') }}</span>
        <span class="sr-only"
            v-show="isFav()">{{ voMsg('tpl.text.removeFavLabel') }}</span>
    </div>

    <a href="javascript:void(0)"
        v-else-if="type == 'link'"
        @click.prevent="toggleFav"
        role="button"
        @keydown.enter.prevent="toggleFav">
        <i aria-hidden="true"
            :class="{'fa-solid fa-heart': isFav(), 'fa-sharp fa-light fa-heart': !isFav()}"></i>
        <span v-show="!isFav()">{{ voMsg('tpl.text.addFavLabel') }}</span>
        <span v-show="isFav()">{{ voMsg('tpl.text.removeFavLabel') }}</span>
    </a>

    <button v-else
        type="button"
        @click="toggleFav">
        <i aria-hidden="true"
            :class="{'fa-solid fa-heart': isFav(), 'fa-sharp fa-light fa-heart': !isFav()}"></i>
        <span v-show="!isFav()">{{ voMsg('tpl.text.addFavLabel') }}</span>
        <span v-show="isFav()">{{ voMsg('tpl.text.removeFavLabel') }}</span>
    </button>
</template>


<script>
    import V from 'voUtils/V.js'

    import {
    	isFav, toggleFav, onFavUpdate, getFavIds
    }
    from 'voUtils/FavStore.js';


    export default {
    	voVueComponent: 'voffice-fav-element',
    	props: {
    		type: String,
    		unitId: Number,
    		addLabel: String,
    		removeLabel: String
    	},
    	computed: {
    		title: function() {
    			return this.voMsg('favorites');
    		}
    	},
    	mounted: function() {
    		onFavUpdate(() => {
    			this.$forceUpdate();
    		});

    	},
    	methods: {

    		isFav: function() {
    			return isFav(this.unitId);
    		},
    		toggleFav: function() {
    			V.log("Fav clicked!", this.unitId);
    			toggleFav(this.unitId);
    		}
    	}


    };
</script>